function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M225.113 50.5835C236.347 50.5835 247.559 55.1307 256.021 64.2671C273.092 82.7483 273.092 113.766 256.357 132.518L219.696 173.068L253.522 208.3L290.184 167.749L290.289 167.624L290.394 167.499C324.893 128.826 324.473 66.5407 289.491 28.6605C272.42 10.1793 249.554 0 225.113 0C213.186 0 201.533 2.44052 190.53 7.25899C179.024 12.286 168.777 19.6493 160.063 29.1611L159.727 29.5366L159.391 29.912L158.026 31.4556L156.661 29.912L156.325 29.5157L155.968 29.1402C147.254 19.6493 137.008 12.2652 125.501 7.23813C114.457 2.44052 102.824 0 90.8974 0C66.4564 0 43.5692 10.1793 26.4983 28.6605C-8.48337 66.5616 -8.88232 128.847 25.6164 167.499L25.7214 167.624L25.8264 167.749L62.4879 208.3L96.3148 173.068L59.6533 132.539C42.9183 113.766 42.9183 82.7691 59.9682 64.2879C68.4302 55.1307 79.6428 50.5835 90.8764 50.6043C102.32 50.6043 113.785 55.3185 122.352 64.6634L157.984 105.214L193.617 64.6634C202.205 55.2976 213.669 50.5835 225.113 50.5835Z",
  fill: "#C4C4C4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M158.065 241.467L96.3959 173.257L62.569 208.488L124.238 276.677L158.065 314.098L191.892 276.677L253.562 208.488L219.735 173.257L158.065 241.467Z",
  fill: "#D1D1D1"
});

var SvgGrayLogo = function SvgGrayLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 316,
    height: 315,
    viewBox: "0 0 316 315",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrayLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gray-logo.7d560b98.svg";
export { ForwardRef as ReactComponent };